import * as React from 'react';
import { ChevronDown } from 'src/assets/icons';

interface DropdownIconProps {
  className: string;
}
export const DropdownIcon: React.FunctionComponent<DropdownIconProps> = ({ className, ...props }) => {
  return (
    <div className={className} {...props}>
      <ChevronDown />
    </div>
  );
};
